import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import Site, { BASE } from './Site';

// Spliced into <Routes> in src/App.js. Everything the site is lives in this folder.
const routes = (
  <>
    <Route path={BASE} element={<Site />} />
    <Route path="/projects/mecharts" element={<Navigate to={BASE} replace />} />
  </>
);

export default routes;
